var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.codePop)?_c('div',{staticClass:"code_pop"},[_c('div',{staticClass:"code_content"},[_c('img',{attrs:{"src":require(`@/assets/img/${_vm.device}/${_vm.region}/home/recharge_code.png`),"alt":""}}),_c('img',{staticClass:"close_btn",attrs:{"src":require("@/assets/img/m/public/popup_close.png"),"alt":""},on:{"click":_vm.closeCodePop}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }